import React from 'react';
import { withHydrator } from '@thd-olt-component-react/hydrator';
import { ComponentPlaceholder } from '@thd-olt-component-react/loading-placeholder';
import { withDynamicComponent, withDynamicImport } from '@thd-nucleus/app-render';
import { withLayoutGroup } from '@thd-olt-component-react/layout-manager';
import {
  propTypes,
  defaultProps,
} from './collectionlist.util';

const ImportedComponent = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('./CollectionList.component')).CollectionList;
  },
  client: () => {
    return import(
      /* webpackPrefetch: true, webpackChunkName: "collection-list-component" */
      './CollectionList.component');
  },
  name: 'CollectionList',
});

const HydratedComponent = withHydrator({
  delay: 1500,
  id: 'product-section-collections',
  placeholder: (
    <ComponentPlaceholder
      height={600}
      rows={10}
      color="#E0E0E0"
      showLoadingAnimation
    />
  ),
  scrollBuffer: 750,
}, ImportedComponent);

const DynamicComponent = withDynamicComponent(HydratedComponent);

export const CollectionListImporter = withLayoutGroup({
  name: 'collections'
}, DynamicComponent);

CollectionListImporter.displayName = 'CollectionListImporter';

CollectionListImporter.propTypes = propTypes;

CollectionListImporter.defaultProps = defaultProps;
